module.exports = __webpack_public_path__ + "img/vva.5a4a7393.png";